import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+User.token
});

// Header fields for the label: patient, practice, address, and workingpan (Pan No).
const GetHeader = (id) =>
    fetch(ApiUrl.LabAdminPrint_Label_Order+"/"+id,{ method:'GET', headers: headers() })
        .then(res=>res.json())
        .then(data=>data.response);

// Tooth data. The label endpoint returns only the order header - no line items and no tooth
// sections - so the chart is sourced from the job card endpoint, which already returns
// `lineItems` with a `sections` object per item. Two calls rather than one, but it keeps this
// entirely in the frontend: no API change and no Node restart to deploy.
// The reverse is not possible - the job card payload drops `workingpan`, which the label prints.
const GetTeeth = (id) =>
    fetch(ApiUrl.LabAdminPrint_Jobcard_Order+"/"+id,{ method:'GET', headers: headers() })
        .then(res=>res.json())
        .then(data=>(data.response && data.response.lineItems) || []);

// Both must resolve before the caller prints. Resolving them separately and printing on the
// first one would print a label with an empty tooth chart.
// A failed tooth fetch degrades to an unmarked chart rather than losing the whole label.
const Get = (id,setValues) =>
    Promise.all([GetHeader(id), GetTeeth(id).catch(()=>[])])
        .then(([header, lineItems])=>{
            setValues(header ? {...header, lineItems} : null);
        });

const Functions = {Get};
export default Functions;
